const parseInternalRoutes = (routes, blockedFeatures) =>
  routes.filter((item) => !blockedFeatures.includes(item.feature));
const blockFeatureIf = (condition, ...items) => (condition ? items : []);

export { parseInternalRoutes, blockFeatureIf };
